// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"6a593faa","317":"b3b8b9ec"}[chunkId] + ".chunk.js";
};